import React from 'react';

export const isCellLoading = (
  loading: any,
  cellsCoords: any,
  rowIndex: any,
  columnId: any,
) => {
  if (!loading) {
    return false;
  }
  return !cellsCoords
    ? true
    : cellsCoords.some(
        (cellCoord: any) =>
          cellCoord[0] === rowIndex && cellCoord[1] === columnId,
      );
};

export const useResizeObserver = (state: any, callback: any) => {
  const columnResizeRef = React.useRef();
  const callbackRef = React.useRef(callback);
  callbackRef.current = callback;

  React.useEffect(() => {
    if (
      state.columnResizing &&
      !state.columnResizing?.isResizingColumn &&
      columnResizeRef.current
    ) {
      callbackRef.current(
        columnResizeRef.current,
        state.columnResizing.columnWidths[columnResizeRef.current],
        state.columnResizing,
      );
    }
    columnResizeRef.current = state.columnResizing?.isResizingColumn;
    // callback excluded from deps — it's inline and changes every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.columnResizing]);
};
